<style lang="scss">

    .logo {
        width: 100%;
        max-width: 200px;
    }

</style>

<img src="/images/logo-checkform.png" alt="Checkform" class="logo">